"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const api_1 = __importDefault(require("../api"));
const types_1 = require("../../types");
const common_1 = require("../common");
const provide_mobile_1 = __importDefault(require("../modals/provide_mobile"));
const verify_otp_1 = __importDefault(require("../modals/verify_otp"));
(0, web_ui_1.$)(document).ready(() => {
    const card = (0, web_ui_1.$)('#client-login-card');
    (0, web_ui_1.$)('#client_login_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const client_dob = (0, web_ui_1.$)('#client_dob');
        const client_secret = (0, web_ui_1.$)('#client_secret');
        const dob = (client_dob.val() || '').trim();
        const secret = ((client_secret.val() || '').trim());
        if (dob.length === 0) {
            return client_dob.addClass('is-invalid');
        }
        else {
            client_dob.removeClass('is-invalid');
        }
        if (!secret.match(/[0-9]{9}/)) {
            return client_secret.addClass('is-invalid');
        }
        else {
            client_secret.removeClass('is-invalid');
        }
        const _dob = web_ui_1.moment.utc(dob).toDate();
        try {
            web_ui_1.LoadingOverlay.show();
            const [result, info] = yield api_1.default.clientLogin({
                birthday: _dob,
                ssn: secret
            });
            if (result === types_1.HTTPError.OK && info) {
                (0, web_ui_1.$)('#client_name').text(`${info.first_name} ${info.last_name}`);
                client_dob.val('');
                client_secret.val('');
                return (0, common_1.swapCard)(card, (0, web_ui_1.$)('#client-portal-card'));
            }
            else if (result === types_1.HTTPError.MOBILE_REQUIRED) {
                web_ui_1.LoadingOverlay.hide();
                return (0, provide_mobile_1.default)({
                    birthday: _dob,
                    ssn: secret
                });
            }
            else if (result === types_1.HTTPError.OTP_REQUIRED) {
                web_ui_1.LoadingOverlay.hide();
                return (0, verify_otp_1.default)({
                    birthday: _dob,
                    ssn: secret
                });
            }
            web_ui_1.LoadingOverlay.hide();
            return web_ui_1.StatusModal.show({
                title: 'Invalid Credentials Supplied',
                body: 'Please check your information and try again'
            });
        }
        catch (_a) {
            web_ui_1.LoadingOverlay.hide();
        }
    }));
    (0, web_ui_1.$)('#client_secret').on('change keyup', event => {
        return (0, common_1.checkSSN)((0, web_ui_1.$)(event.target));
    });
});
